export default {
  filters: {
    groupCharacters: function (value, repeatAfterCount = 4, delimiter = " ") {
      const repeatRegExp = new RegExp(`.{1,${repeatAfterCount}}`, "g")
      const parts = value.replace(" ", "").match(repeatRegExp)
      return parts.join(delimiter)
    }
  }
}
